import React from 'react';
import { concat, conj, get, hash, hashMap, map, vector, toClj, toJs } from 'mori';
import Wahanda from 'common/wahanda';
import SummaryRowsView from './row';
import {
  excludeRedeemedVoucherPayments,
  formatVoucherLabel,
  getByType,
  RedeemedVoucherLineItem,
} from '../utils';
// @ts-expect-error ts-migrate(2430) FIXME: Type '{}' is not assignable to type 'string'.
interface IPricingProps extends React.HTMLAttributes<Element> {
  isCancellation: boolean;
  data: {};
  lang: {};
}

export default class Pricing extends React.Component<IPricingProps, {}> {
  render() {
    const { isCancellation, data, lang } = this.props;
    const getPaymentType = (paymentMethod) => {
      const t = get(paymentMethod, getByType(isCancellation, 'type', 'paymentType'));
      // Different types: one is for checkout, another - for refund...
      // for this use case, we simplify that to VOUCHER,
      // but we should refactor this...
      return t === 'VCHR' ? 'VOUCHER' : t;
    };
    const totals = get(data, getByType(isCancellation, 'checkoutTotals', 'cancellationTotals'));
    const terminalTipAmount = get(totals, 'totalTerminalTipAmount') || 0;
    const tipAmount = (get(totals, 'totalTipAmount') || 0) + terminalTipAmount;
    const total =
      Math.abs(get(totals, getByType(isCancellation, 'totalAmount', 'overallAmount'))) +
      terminalTipAmount;
    const redeemedVouchers: RedeemedVoucherLineItem[] =
      toJs(
        get(
          data,
          getByType(
            isCancellation,
            'redeemedVoucherLineItems',
            'cancelledRedeemedVoucherLineItems',
          ),
        ),
      ) || [];
    const payments = toClj(
      excludeRedeemedVoucherPayments(
        toJs(get(data, getByType(isCancellation, 'payments', 'refunds'))) || [],
        redeemedVouchers,
      ),
    );
    const redeemedVoucherRows = vector(
      ...redeemedVouchers.map((voucher, index) => (
        <SummaryRowsView
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentVoucher' does not exist on type '{}'.
          name={formatVoucherLabel(voucher, lang.paymentVoucher)}
          totalPrice={voucher.amount}
          negative={!isCancellation}
          key={`redeemed-voucher-${voucher.id ?? index}`}
        />
      )),
    );
    const paymentMethods = map((paymentMethod) => {
      const paymentType = getPaymentType(paymentMethod);
      const names = hashMap(
        'CASH',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentCash' does not exist on type '{}'... Remove this comment to see the full error message
        lang.paymentCash,
        'change',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentChange' does not exist on type '{... Remove this comment to see the full error message
        lang.paymentChange,
        'CARD',
        get(paymentMethod, 'cardType') ?? Wahanda.lang.reports.transactions.table.payments.card,
        'VOUCHER',
        formatVoucherLabel(
          {
            voucherIssuer: get(paymentMethod, 'voucherIssuer', ''),
            voucherCode: get(paymentMethod, 'voucherCode'),
          },
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentVoucher' does not exist on type '... Remove this comment to see the full error message
          lang.paymentVoucher,
        ),
        'tip',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'tip' does not exist on type '{}'.
        lang.tip,
        'TTPY',
        'Tap To Pay',
        // https://wahanda.slack.com/archives/C08K3GR47DG/p1759235573709359?thread_ts=1759235487.188349&cid=C08K3GR47DG
        'TRMN',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentTerminal' does not exist on type '{}'.
        lang.paymentTerminal,
      );
      const toRow = (_isCancellation, _paymentType, totalPrice) => (
        <SummaryRowsView
          name={get(names, _paymentType)}
          hideZero
          totalPrice={totalPrice}
          negative={_isCancellation}
          key={`row-${_paymentType}-${hash(paymentMethod)}`}
        />
      );
      const row = toRow(isCancellation, paymentType, get(paymentMethod, 'amount'));
      if (paymentType === 'CASH' && get(totals, 'totalChangeAmount') > 0) {
        const rows = vector(row, toRow(isCancellation, 'change', get(totals, 'totalChangeAmount')));
        return rows;
      }
      return row;
    }, payments);
    const totalRows = (() => {
      const totalRow = (
        <SummaryRowsView
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'totalPrice' does not exist on type '{}'.
          name={lang.totalPrice}
          totalPrice={total}
          additionalClass={isCancellation ? 'total refund-amount' : 'total'}
          negative={isCancellation}
          key="total"
        />
      );
      let rows = vector(totalRow);
      if (get(totals, getByType(isCancellation, 'totalAmountPrePaid', 'prepaidRefundsAmount'))) {
        const amount = Math.abs(
          get(totals, getByType(isCancellation, 'totalAmountPrePaid', 'prepaidRefundsAmount')),
        );
        rows = conj(
          rows,
          <SummaryRowsView
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'prepaid' does not exist on type '{}'.
            name={lang.prepaid}
            totalPrice={amount}
            negative={isCancellation}
            key="total-prepay"
          />,
        );
      }
      // Cancellations have no deposit-refund total on the backend yet.
      if (!isCancellation && get(totals, 'totalDepositAmount')) {
        rows = conj(
          rows,
          <SummaryRowsView
            // @ts-expect-error ts-migrate(2339)
            name={lang.deposit}
            totalPrice={get(totals, 'totalDepositAmount')}
            negative={false}
            key="total-deposit"
          />,
        );
      }
      return rows;
    })();
    const cardTip = (() => {
      if (tipAmount) {
        return vector(
          <SummaryRowsView
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'tip' does not exist on type '{}'.
            name={lang.tip}
            totalPrice={tipAmount}
            hideZero
            negative={isCancellation}
            key="total-tip-amount"
          />,
        );
      }
      return null;
    })();
    return (
      <div className="transaction-dialog-pricing-section">
        {toJs(concat(redeemedVoucherRows, totalRows, paymentMethods, cardTip))}
      </div>
    );
  }
}
